export default "__VITE_ASSET__UZvmQTF6__"